function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 11a2.5 2.5 0 012.5 2.5v15a2.5 2.5 0 11-5 0v-15a2.5 2.5 0 012.5-2.5zm9 0a2.5 2.5 0 012.5 2.5v15a2.5 2.5 0 11-5 0v-15a2.5 2.5 0 012.5-2.5z",
  fill: "#434A54",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42"
  }, props), _ref);
};

export default SvgComponent;